import React, { useEffect, useRef, useState } from "react";

const TicketShop = ({ scriptString }) => {
  const containerRef = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (scriptString) {
      const parser = new DOMParser();
      try {
        const scriptEl = parser
          .parseFromString(scriptString, "text/html")
          .getElementsByTagName("script")[0];

        const script = document.createElement("script");
        for (let i = 0; i < scriptEl.attributes.length; i++) {
          script.setAttribute(
            scriptEl.attributes[i].nodeName,
            scriptEl.attributes[i].value
          );
        }

        if (containerRef.current.childElementCount === 0) {
          containerRef.current.appendChild(script);
        }
      } catch (e) {
        setError(true);
      }
    }
  }, [scriptString]);

  return (
    <div ref={containerRef}>
      {error && (
        <div style={{ border: "1px solid red", padding: "32px" }}>
          Could not parse ticket shop tag. Please check embed code.
        </div>
      )}
    </div>
  );
};

export default TicketShop;
